import { render, staticRenderFns } from "./noCause.vue?vue&type=template&id=720cd9ff&scoped=true&"
import script from "./noCause.vue?vue&type=script&lang=js&"
export * from "./noCause.vue?vue&type=script&lang=js&"
import style0 from "./noCause.vue?vue&type=style&index=0&id=720cd9ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720cd9ff",
  null
  
)

export default component.exports